var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDribbble = function SvgDribbble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.033,
    cy: 12.054,
    fill: "#EF548A",
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm7.861 5.84a9.94 9.94 0 0 1 2.134 6.068c-2.475-.569-4.754-.707-6.865-.429a37.81 37.81 0 0 0-.85-1.853c2.078-.888 3.932-2.11 5.581-3.787zm-1.38-1.442a14.756 14.756 0 0 1-5.128 3.478A45.694 45.694 0 0 0 9.646 2.29 9.96 9.96 0 0 1 12 2c2.472 0 4.733.907 6.48 2.398zM7.666 3.002c1.468 1.856 2.72 3.687 3.781 5.537-2.465.724-5.45 1.126-9.202 1.287a10.024 10.024 0 0 1 5.421-6.824zm-5.658 8.835c3.94-.15 7.39-.55 10.404-1.508.258.513.504 1.028.734 1.547-3.374.933-6.287 3.082-8.848 6.495A9.953 9.953 0 0 1 2 12c0-.055.007-.108.008-.163zm3.732 7.95c2.378-3.244 5.04-5.24 8.164-6.044.888 2.368 1.52 4.835 1.927 7.491A9.942 9.942 0 0 1 12 22a9.947 9.947 0 0 1-6.26-2.213zm11.947.428a39.046 39.046 0 0 0-1.79-6.807c1.814-.173 3.774-.004 5.914.513a10.014 10.014 0 0 1-4.124 6.294z",
    fill: "#C72263"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 .25c5.329 0 9.844 3.442 11.47 8.22C21.964 3.567 17.4 0 12 0S2.037 3.566.53 8.47C2.155 3.693 6.67.25 12 .25z",
    fill: "#FFF",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.75A12.072 12.072 0 0 1 .54 15.568 11.96 11.96 0 0 0 12 24a11.975 11.975 0 0 0 11.465-8.445A12.088 12.088 0 0 1 12 23.75z",
    fill: "#010101",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "dribbble_svg__a",
    x1: 1.125,
    x2: 22.875,
    y1: 6.929,
    y2: 17.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z",
    fill: "url(#dribbble_svg__a)"
  })));
};

export default SvgDribbble;